const passwordVerification = (password) => {
    if (password.length < 8) {
        return "Your password must be at least 8 characters";
    }
    if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.!@#$%^&*])[A-Za-z\d.!@#$%^&*]+$/)) {
        return "Your password must contain at least 1 capital letter, 1 lower case letter, 1 number, and 1 spechal character (.!@#$%^&*).";
    }
}

export default passwordVerification;